import React from "react";
import { Grid, Box } from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import { GMB } from "../../../services/gmbApiConfig";

const GoogleMap = ({ lat, long, map_url }) => {
  const embedUrl =
    lat && long && GMB.GOOGLE_MAPS_BASE_URL
      ? `${GMB.GOOGLE_MAPS_BASE_URL}&center=${lat},${long}&zoom=18`
      : "";

  return (
    <Grid className="flex flex-grow" item xs={6}>
      <Box
        sx={{
          border: "1px solid #E4EAF0",
          borderRadius: "16px",
          height: "100%",
          width: "100%",
          position: "relative", // For absolute positioning of the icon
        }}
      >
        {!embedUrl && (
          <div
            className="flex flex-col justify-center items-center	h-[100%] w-[100%]
		   rounded-lg"
          >
            <MapPlaceholder />
          </div>
        )}

        {embedUrl && (
          <iframe 
          
            src={embedUrl}
            width="100%"
            height="100%"
            style={{ border: 0, borderRadius: "16px" }}
            loading="lazy"
            title="Google Map"
          />
        )}

        {/* Icon positioned at the top right corner */}
        {map_url && (
          <Box
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              cursor: "pointer",
              backgroundColor: "black",
              borderRadius: "50%",
              padding: "4px",
            }}
            onClick={() => window.open(map_url, "_blank")}
          >
            <ArrowOutwardIcon className="text-white" />
          </Box>
        )}
      </Box>
    </Grid>
  );
};

function MapPlaceholder() {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="mb-2 text-gray-400"
    >
      <path
        d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z"
        fill="currentColor"
      />
      <path
        d="M3 3L21 21"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default GoogleMap;
